export const SPECIAL_TEXTS_ENG: Record<string, string> = {
    "CHILD_RELATIVE": "Child" //in sensul de ruda
};